import React from 'react';
import { Paper, makeStyles } from '@material-ui/core';
import { styles } from 'components/Table/Table.styles';
import TableToolbar from 'components/TableToolbar';
import Table from 'components/Table/Table';
import ConnectedTableFilters from 'components/Table/ConnectedTableFilters';
import { TableConfigEntry } from 'utils/tableConfig';
import InternalLink from 'components/Link/InternalLink';
import { getReadableDate } from 'utils/utils';
import { useTagRelationTypes } from 'novaApi/hooks/tag_relation_type';
import ConnectedButton from 'components/Button/ConnectedButton';

const useStyles = makeStyles(styles);

const tableConfig: TableConfigEntry<Nl.Api.TagRelationType> = {
  columnData: [
    {
      id: 'name',
      label: 'Name',
      isSortable: true,
      render: ({ uuid, name }) => (
        <InternalLink
          color='inherit'
          to={{ type: 'route/TAG_RELATION_TYPES_EDIT', payload: { uuid } }}
        >
          {name}
        </InternalLink>
      ),
    },
    {
      id: 'description',
      label: 'Description',
      isSortable: true,
      render: ({ description }) => description,
    },
    {
      id: 'created_at',
      label: 'Created',
      isSortable: true,
      render: ({ created_at }) => getReadableDate(created_at) || '-',
    },
    {
      id: 'updated_at',
      label: 'Last Modified',
      isSortable: true,
      render: ({ updated_at }) => getReadableDate(updated_at) || '-',
    },
  ],
};

export default function TagRelationTypesPage() {
  const classes = useStyles({});
  const { data, isLoaded } = useTagRelationTypes();

  return (
    <Paper elevation={1} className={classes.root}>
      <TableToolbar
        title='Tag Relation Types'
        search={
          <ConnectedTableFilters
            filters={[
              {
                type: 'search',
                size: 6,
                label: 'Search by name',
                queryFilterKey: 'name',
                e2e: 'tagRelationType-search-name',
              },
            ]}
          />
        }
        actions={
          <ConnectedButton
            icon='add'
            fab
            route='route/TAG_RELATION_TYPES_CREATE'
            label='Create new Tag Relation Type'
            permission='CAN_CREATE_TAG_RELATION_TYPE'
          />
        }
      />
      <Table
        config={tableConfig}
        data={data?.tag_relation_types}
        isLoaded={isLoaded}
        paginationData={data}
      />
    </Paper>
  );
}
